"use client";

import {useEffect} from "react";
import {useNextStep} from "nextstepjs";
import {trackTourOnScreen} from "@/utils/acknowledgements/tourVisit";

/** Lets one-time tips outside this tour's provider wait while the tour is showing. */
export default function TourOnScreenReporter() {
   const {isNextStepVisible} = useNextStep();
   useEffect(() => (isNextStepVisible ? trackTourOnScreen() : undefined), [isNextStepVisible]);
   return null;
}
